module.exports = __webpack_public_path__ + "tables/media/Email_outlined.339db59a.svg";